// Basin coverage map (hex fill layers + outline traces), fetched once per page load.
//
// The URL is content-hashed (see scripts/build-coverage.js), so the browser can
// cache it indefinitely and a new version always gets a new URL.
const COVERAGE_URL = `${process.env.BASE_URL}${process.env.VUE_APP_COVERAGE_FILE}`

let coveragePromise = null

export function getCoverage() {
  if (!coveragePromise) {
    coveragePromise = fetch(COVERAGE_URL)
      .then((response) => {
        if (!response.ok) throw new Error(`Failed to load coverage map (${response.status})`)
        return response.json()
      })
      .then(deepFreeze)
      .catch((err) => {
        coveragePromise = null // Allow a later call to retry
        throw err
      })
  }
  return coveragePromise
}

// Warm the cache in the background without competing with the initial page load
export function prefetchCoverage() {
  const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 2000))
  idle(() => getCoverage().catch(() => {}))
}

// The result is shared by every map, so make it read-only. Frozen objects are
// also skipped by Vue's reactivity, which avoids walking thousands of coordinates.
function deepFreeze(obj) {
  Object.values(obj).forEach((value) => {
    if (value && typeof value === 'object') deepFreeze(value)
  })
  return Object.freeze(obj)
}
